<!-- Ficha em analise direta -->
<div class="timeline-badge">
    <a>
        <em class="fa fa-circle"></em>
    </a>
</div>

<h4 *ngIf="timelineActive">{{ timeline.dataHora | date:'HH:mm'}}
    <small>{{ timeline.dataHora | date:'dd/MM/yyyy'}}</small>
</h4>

<div class="timeline-panel" [ngClass]="{'timeline-panel-disabled': !timelineActive}">

    <div class="step">
        <span class="icon"></span>
        <h2>{{ timeline.tituloStatus }}</h2>
        <span>{{ timeline.subTituloStatus}}</span>

        <div *ngIf="timelineActive" class="specifications">
            <div class="col-xs-6 icon-stats">
                <span class="icon wait"></span>
                <span class="stats">
                    <small>{{ timeline.cardDireito[0].valor }}</small>
                    120 min
                </span>
            </div>

            <div class="col-xs-6">
                <div class="row operator">
                    <img class="user-photo margin-0" appFallbackImage src="{{ timeline.urlFotoUsuarioAcao }}" border="0" alt="Foto do Usuário."/>
                    <span class="name">
                        <span>
                            <small>Analista</small>
                            {{ timeline.usuarioAcao }}
                        </span>
                    </span>
                </div>
            </div>
        </div>
        <app-ficha-timeline-sos-respondido *ngIf="timeline?.cardDireito[2]?.valor === 'SOS_RESPONDIDO'" [acoes]="timeline.cardDireito[2].acoes"
            [timelineActive]="timelineActive"></app-ficha-timeline-sos-respondido>
        <app-ficha-timeline-sos *ngIf="timeline?.cardDireito[2]?.valor === 'SOS'" [produtoProposta]="produtoProposta" [dataLimiteAtendimento]="timeline.dataLimiteAtendimento"
            [cardDireito]="timeline.cardDireito[2]" [cliente]="cliente" [idFicha]="idFicha" [timelineActive]="timelineActive"></app-ficha-timeline-sos>
    </div>
</div>
